import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { getLightBorder } from 'Components/utils';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Spacer from 'Components/UI/Spacer';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { useRightSidebarContext } from 'Views/Page/Content/RightSidebar/RightSidebarContext';
import PropTypes from 'prop-types';

const useStyles = buildUseStyles('Header', ((theme) => ({
  root: {
    padding: theme.spacing(1, 2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    ...getLightBorder(theme, { bottom: true }),
    marginBottom: theme.spacing(2),
    position: 'sticky',
    top: theme.heights.advisorNavigationHeight,
    backgroundColor: theme.palette.common.white,
    zIndex: 100,
  },
})));

const Header = ({ title }) => {
  const { clearRightSidebarCollection } = useRightSidebarContext();

  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Text
        value={title}
        variant={'h2'}
        weight={'bold'}
        align={'left'}
      />
      <Spacer />
      <IconButton
        onClick={() => {
          clearRightSidebarCollection();
        }}
        icon={CloseIcon}
        title={'Close'}
      />
    </Box>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Header;
